<template>
  <div>
    <van-form ref="myForm">
      <div class="information-box">
        <div class="item item2">
          <van-field :label="$t('form.label.interview.object')"
            v-model="form.interviewTarget" rows="4" 
            autosize type="textarea" 
            maxlength="50" show-word-limit
            :placeholder="$t('form.label.enter')"
            class="short-textarea">
            <template #label>
              {{$t('form.label.interview.object')}}
            </template>
          </van-field>
        </div>
        <div class="item">
          <van-field 
            :value="form.interviewTime ? form.interviewTime : ''"
            :label="$t('form.label.interview.date')" 
            right-icon="arrow"
            :placeholder="$t('form.label.choice')"
            readonly clickable
            @click="showDatePicker = true">
            <template #label>
              {{$t('form.label.interview.date')}}
            </template>
          </van-field>
        </div>
        <div class="item">
          <van-field 
            :value="form.interviewStart && form.interviewEnd ? form.interviewStart + '-' + form.interviewEnd : ''"
            :label="$t('form.label.interview.time')" 
            right-icon="arrow"
            :placeholder="$t('form.label.choice')"
            readonly clickable
            @click="showTimePicker = true">
            <template #label>
              {{$t('form.label.interview.time')}}
            </template>
          </van-field>
        </div>
        <div class="item item2">
          <van-field :label="$t('form.label.interview.theme')"
            v-model="form.interviewTopic" rows="4" 
            autosize type="textarea" 
            maxlength="50" show-word-limit
            :placeholder="$t('form.label.enter')"
            class="short-textarea">
            <template #label>
              {{$t('form.label.interview.theme')}}
            </template>
          </van-field>
        </div>
        <div class="item item2">
          <van-field :label="$t('form.label.interview.problem')"
            v-model="form.interviewProblem" rows="5" 
            autosize type="textarea" 
            maxlength="500" show-word-limit
            :placeholder="$t('form.label.enter')">
            <template #label>
              {{$t('form.label.interview.problem')}}
            </template>
          </van-field>
        </div>
      </div>
    </van-form>
    <!-- 时间选择 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        :default="{currentTime: form.interviewTime ? form.interviewTime : ''}"
        v-model="currentDate"
        type="date"
        :title="$t3('选择日期', 'Select date')"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"/>
    </van-popup>
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="form.interviewStart"
        type="time"
        @confirm="onTimeConfirm"
        @cancel="showTimePicker = false"
        :title="$t3('开始时间', 'Start time')"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="form.interviewEnd"
        type="time"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        :title="$t3('结束时间', 'End time')"
      />
    </van-popup>
  </div>
</template>

<script>

import { objectMergLeft, fixedNumber } from '@/utils'

const tmpForm = {
  id: undefined,
  interviewTarget: undefined,
  interviewTime: undefined,
  interviewStart: undefined,
  interviewEnd: undefined,
  interviewTopic: undefined,
  interviewProblem: undefined
}

export default {
  name: 'interviewInte',
  data () {
    return {
      star: require('@/assets/img/asterisk.svg'),
      form: {},
      rules: {
        // interviewTarget: [{ msg: ['采访对象不能为空', 'interview target is required.'] }],
        // interviewTime: [{ msg: ['请选择意向时间', 'Please select time'] }],
        // interviewTopic: [{ msg: ['采访主题不能为空', 'interview topic is required.'] }],
        // interviewProblem: [{ msg: ['采访问题不能为空', 'interview problem is required.'] }]
      },
      problem: '',
      theme: '',
      object: '',
      value: '',
      showPicker: false,
      showTimePicker: false,
      showDatePicker: false,
      currentDate: new Date(),
    }
  },
  methods: {
    fixedNumber,
    initForm (form) {
      this.form = Object.assign({}, tmpForm)
      objectMergLeft(this.form, form)
    },
    validate () {
      return this.$validateI18n(this.form, this.rules)
    },
    onConfirm() {
      const startHour = parseInt(this.form.interviewStart)
      const endHour = parseInt(this.form.interviewEnd)
      const startMin = parseInt(this.form.interviewStart.substring(3))
      const endMin = parseInt(this.form.interviewEnd.substring(3))
      if (startHour > endHour || (startHour === endHour && startMin >= endMin)) {
        const tmpTime = this.form.interviewStart
        this.form.interviewStart = this.form.interviewEnd
        this.form.interviewEnd = tmpTime
      }
      this.showPicker = false
    },
    onDateConfirm (date) {
      this.form.interviewTime = date.getFullYear() + '-' + `${fixedNumber(date.getMonth() + 1)}-${fixedNumber(date.getDate())} `
      this.showDatePicker = false
    },
    onTimeConfirm (date) {
      this.form.interviewStart = date
      this.form.interviewEnd = this.form.interviewStart
      this.showTimePicker = false
      this.showPicker = true
    },
  }
}
</script>